// extracted by mini-css-extract-plugin
export default {"field":"Billing_field__F3Glb","ellipsis":"Billing_ellipsis__ipEME","accordionContainer":"Billing_accordionContainer__OZZ1H"};